/*
 * Ajaxify Cart
 */
window.onload = function(){

  Shopify.AjaxifyCart = (function($){

    var init = function(){
      $(document).ready(function(){
        $('form[action="/cart/add"]').submit(function(e){
          e.preventDefault();
          var t = $(this),
              b = t.find('[type="submit"]'),
              count = $('.cart-total');
          //Add to cart
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: t.serialize(),
            success: function(itemData){              
              //Update cart count
              $.getJSON('/cart.js', function(cart){
                if(count.length){
                  count.text(cart.item_count);
                }
              });
              //Unable "add to cart" button
              b.text(b.data('added')).prop('disabled', true).addClass('added');
              //Re-enable "add to cart" button
              setTimeout(function(){
                b.text(b.data('add')).prop('disabled', false).removeClass('added');
              }, 1000);
            }, 
            error: function(XMLHttpRequest){
              var response = eval('(' + XMLHttpRequest.responseText + ')');
              response = response.description;
              if(response.slice(0,4) === 'All '){
                b.text(b.data('sold')).prop('disabled', true).addClass('disabled sold-out');
              }else{  
                b.text(b.data('error')).prop('disabled', true).addClass('disabled error');
                setTimeout(function(){
                  b.text(b.data('add')).prop('disabled', false).removeClass('disabled error');
                }, 1000);
              }
            }
          });   
          return false;
        });
      });
    };
    return{
      init: function(params){
          //Configuration
          params = params || {};
          //Merging with defaults
          $.extend(params);
          //Action
          $(function(){
            init();
          });
      }
    }
  })(jQuery);
  Shopify.AjaxifyCart.init();
}